export default function wpBlockFunctionality() {
  wrapMediaBlockAnchorBtn();
  changeHandpickedProductsHref();
  rebuildHandpickedProducts();
  imageWithLinks();
  imagesLinkBlockSliderFunctionality();
  imagesLinkBlock();
}

function wrapMediaBlockAnchorBtn() {
  $('.block-media-text .wp-block-media-text__content a').each(function () {
    const linktext = $(this).html();
    $(this).html(linktext + '<div class="media-text-link-btn"></div>');
  });
}

function changeHandpickedProductsHref() {
  if ($('.wp-block-handpicked-products').length == 0)
    return;

  $('.wp-block-handpicked-products .wc-block-grid__product').each(function() {
    const href = $('.wc-block-grid__product-link', this).attr('href');
    $('.add_to_cart_button', this).attr('href', href);
  });
}

function rebuildHandpickedProducts() {
  $('.wc-block-grid__product').each(function() {
    $('.wc-block-grid__product-link img', this).prependTo($('.wc-block-grid__product-link', this));
    $('.wp-block-button a', this).appendTo($('.single-product-info', this));
  });
}

function imageWithLinks() {
  if ($('.interactive-image').length) {
    $('.interactive-image').each(function() {
      const parent = this;
      const linksArr = [];

      $('.hidden-data-field .data', parent).each(function() {
        linksArr.push({
          linkData: $('.link-data', this).text(),
          coordinateData: $('.coordinate-data', this).text(),
          linkText: $('.linktext-data', this).text()
        });
      });

      linksArr.forEach(function(marker) {
        const coordinatesArr = marker.coordinateData.split(':');
        const coordinateX = +coordinatesArr[0] * 100;
        const coordinateY = +coordinatesArr[1] * 100;

        let imageMarkers = '<div class="image-marker" style="left: ' + coordinateX + '%; bottom: ' + coordinateY + '%">';
        imageMarkers += '<a href="' + marker.linkData + '"><div class="linktext">' + marker.linkText + '</div></a></div>';
        $('.int-img-wrapper picture', parent).append(imageMarkers);
      });

      $('.image-marker', parent).each(function() {
        $(this).click(function(e) {
          $('a', this).toggleClass('imagemarker-showtext');
        });
      });
    });
  }
}

function imagesLinkBlockSliderFunctionality() {
  if (!document.querySelector('.interactive-images-container')) return;

  const sliders = [...document.querySelectorAll('.interactive-images-container')];

  for (const slider of sliders) {
    // Om det bara finns en bild i slidern kan vi ta bort pilarna och bryta efter det
    const imageCount = slider.querySelectorAll('.single-interactive-image').length;

    if (imageCount === 1) {
      for (const sliderArrow of document.querySelectorAll('.slider-arrow')) {
        sliderArrow.remove();
      }

      return;
    }

    const currentSlider = $('.single-interactive-images', slider).slick({
      slidesToShow: 1,
      focusOnSelect: false,
      nextArrow: '<div class="right-arrow slider-arrow"><div class="arrow">></div></div>',
      prevArrow: '<div class="left-arrow slider-arrow"><div class="arrow"><</div></div>'
    });

    if (sliders.length === 1)
      addArrowKeyNavigationToSlider(currentSlider);
  }
}

function addArrowKeyNavigationToSlider(slider) {
  document.addEventListener('keydown', function(event) {
    if (event.key === 'ArrowRight')
      $(slider).slick('slickNext');
    else if (event.key === 'ArrowLeft')
      $(slider).slick('slickPrev');
  });
}

function imagesLinkBlock() {
  if ($('.interactive-images-container').length > 0) {
    // Placera ut knappar på bilderna
    const parent = $('.interactive-images-container');
    $('.single-interactive-image', parent).each(function() {
      const parent = this;
      const linksArr = [];

      $('.hidden-data-field .data', parent).each(function() {
        linksArr.push({
          linkData: $('.link-data', this).text(),
          coordinateData: $('.coordinate-data', this).text(),
          linkText: $('.linktext-data', this).text()
        });
      });

      linksArr.forEach(function(marker) {
        const coordinatesArr = marker.coordinateData.split(':');
        const coordinateX = +coordinatesArr[0] * 100;
        const coordinateY = +coordinatesArr[1] * 100;

        let imageMarkers = '<div class="image-marker" style="left: ' + coordinateX + '%; bottom: ' + coordinateY + '%">';
        imageMarkers += '<a target="_blank" href="' + marker.linkData + '"><div class="linktext">' + marker.linkText + '</div></a></div>';
        $('.int-img-wrapper picture', parent).append(imageMarkers);
      });

      $('.image-marker', parent).each(function() {
        $(this).click(function(e) {
          $('a', this).toggleClass('imagemarker-showtext');
        });
      });
    });
  }
}
